module.exports = __webpack_public_path__ + "img/livestream.16e3035b.jpg";